export const initialState = {
  loading: false,
  documents: {} as { [id: string]: any },
  isReady: false,
};

export type CmsState = Readonly<typeof initialState>;
